const STATUS_MAP = {
  active: ['Active', 'success'], enabled: ['Active', 'success'], approved: ['Active', 'success'], healthy: ['Active', 'success'],
  inactive: ['Inactive', 'neutral'], pending: ['Pending', 'warning'], processing: ['Pending', 'warning'],
  archived: ['Archived', 'neutral'], disabled: ['Disabled', 'danger'], failed: ['Failed', 'danger'], error: ['Failed', 'danger'],
  degraded: ['Degraded', 'warning'], completed: ['Completed', 'success'], complete: ['Completed', 'success'],
  expired: ['Expired', 'neutral'], revoked: ['Revoked', 'danger'], draft: ['Draft', 'neutral'],
};

export const presentStatus = (value, fallback = 'Inactive') => {
  const key = String(value || fallback).trim().toLowerCase().replaceAll(' ', '_');
  const mapped = STATUS_MAP[key];
  if (mapped) return { label: mapped[0], tone: mapped[1], source: value };
  return { label: String(value || fallback).replaceAll('_', ' '), tone: 'neutral', source: value };
};

export const presentEntityStatus = (entity = {}) => presentStatus(
  entity.archived === true || entity.isActive === false ? 'archived' : entity.status || 'active',
);

export const formatAdminDate = (value, options = {}) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('en-IN', options.withTime
    ? { dateStyle: 'medium', timeStyle: 'short' }
    : { dateStyle: 'medium' }).format(date);
};

export const shortenIdentifier = (value, visible = 6) => {
  const text = String(value || '');
  if (!text) return '—';
  if (text.length <= visible * 2 + 1) return text;
  return `${text.slice(0, visible)}…${text.slice(-visible)}`;
};

export const safeAdminError = (error, fallback = 'This information could not be loaded.') => {
  const status = Number(error?.status || error?.response?.status);
  if (status === 401 || status === 403) return 'You do not have permission to complete this action.';
  if (status >= 500) return `${fallback} Try again in a moment.`;
  return fallback;
};

export const SUPER_ADMIN_TERMINOLOGY = Object.freeze({
  inspect: 'View details',
  edit: 'Edit',
  archive: 'Archive',
  restore: 'Restore',
  disable: 'Disable',
  enable: 'Enable',
  revoke: 'Revoke',
  developerDetails: 'Developer details',
});
